import { put , call, takeEvery} from 'redux-saga/effects';
import {setApiStatus, getApprovalList, setSideNavs, setSelectedTab} from '../actions/ApprovalListActions';
import ApprovalService from "../services/ApprovalService";
import { getApprovalListDataModel } from '../models/ApprovalListDto';


export function* approvalFlowSaga(){

    yield takeEvery('GET_APPROVAL_FLOW', function* (action){
        const { customerGuid } = action;
        yield call(approvalFlowActionSaga,customerGuid);
    })  
}

export function* approvalFlowActionSaga(customerGuid){    
    try{
        const response = yield call(ApprovalService.getApprovalFlows,customerGuid);
        yield put(setApiStatus(true));
        if (response) {
            let sidePanelData = getApprovalListDataModel(response.data);
            // set side nav panels
            yield put(setSideNavs(sidePanelData));
            //set first one as selected tab ID, workflowID
            let flowInfoId = sidePanelData[0].id;
            yield put(setSelectedTab(flowInfoId));
            // get approvalList
            yield put(getApprovalList(flowInfoId));
        }
        
    }catch(error){
        yield put(setApiStatus(false));
    }
    
}

